export default "__VITE_ASSET__C$apfMb___"